<template>
<div id="calendarComponent">
<br>
    <div class="alert alert-danger" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
        </div>
        <div class="alert alert-info" v-if="alertMsg">
        <p> {{alertMsg}}</p>
    </div>
  
  
  <div class="col-md-10">
  
  
  <div id="calendar">
                
  </div>
   <div class="remove-margins col-sm-12 col-xs-12">
                <br>
                <button class="btn-block btn btn-info" @click="addNewEventButton()">Add a new event</button>
                <button class="btn-block btn btn-lg btn-success" @click="goDashboard()">Go to dashboard</button>
            
            </div>
  </div>
 
  <div id="calModal" class="modal fade">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
          <h4 v-if="tempEvent.type==1"  class="modal-title"><i class="fa fa-paw"></i> {{tempEvent.title}}</h4>
          <h4 v-if="tempEvent.type==0"  class="modal-title"><i class="fa fa-plane"></i> {{tempEvent.title}}</h4>
          <h4 v-if="tempEvent.type==2"  class="modal-title"><i class="fa fa-paw"></i> {{tempEvent.title}}</h4>
        </div>
        <div id="modalBody" class="modal-body">
         <h4><strong> {{tempEvent.start}} </strong> to <strong> {{tempEvent.end}} </strong></h4>
          <div v-if="tempEvent.type==1">
                <h4>This event cant be deleted, it's associated with <strong><a @click="goReservation(tempEvent.reservationId)" href="javascript:;">Booking: {{tempEvent.bookingNumber}}</a></strong></h4>
                <div v-if="tempEvent.blocking==true" class="alert h4 alert-info alert-dismissible" role="alert" >
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    No one else can book you for these dates, to change this click here
                    <strong><a href="javascript:;" @click="noBlocking(tempEvent.id)"> mark as available </a></strong>
                </div>
                <div v-if="tempEvent.blocking==false" class="alert h4 alert-info alert-dismissible" role="alert" >
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    People will still be able to book you during these dates.
                    <strong><a href="javascript:;" @click="noBlocking(tempEvent.id)"> mark as un-available </a></strong>
                </div>
                <alert > <strong>click here</strong></alert>
          </div>
          <h4 v-if="tempEvent.type==0 || tempEvent.type==2">Click delete to remove this event from your calendar</h4>
          
          
        </div>
        <div class="modal-footer">
        <button v-if="tempEvent.type==0 || tempEvent.type==2" class="btn btn-title btn-info" @click="deleteEvent">Delete</button>
          <button type="button" class="btn btn-title btn-default" data-dismiss="modal">Close</button>
          
        </div>
      </div>
    </div>

  </div>


  <div  id="newEntryModal" class="modal fade">
    <div  class="modal-dialog">
      <div   class="modal-content">
        <div  class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">×</span> <span class="sr-only">close</span></button>
          <h3 id="newModalTitle" class="modal-title"><i class="fa fa-calendar"></i> {{scheduleComp}}</h3>
        </div>
         <div id="newModalBody">
            <div class="col-md-12">
            
            <br>
            <div class="col-md-8 remove-margins">
              <p><h4>Choose Event Type</h4></p>
                <div class='form-group'>
                            <select id="eventTypes" required v-if="eventTypes"  name="eventTypes" class="form-control input-text" v-model="newEvent.eventType">
                            <option v-for="event in eventTypes" v-bind:value="event.type">
                                {{event.title}}
                            </option>
                            </select>
                </div>
                </div>
                <br>
                
            <div class="col-md-12 remove-margins">
            <div class="col-md-4 remove-margins margin-big-right">
              <h4 style="margin-bottom:2px">From</h4>
              <div class="form-group">
                <div class='input-group date' id='datetimepickerFrom'>
                      <label type='text' readonly="true" v-model="newEvent.start" class="form-control " >{{newEvent.start}}</label>
                  <span class="input-group-addon">
                        <span class="glyphicon glyphicon-calendar"></span>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 remove-margins margin-big-left">
              <h4 style="margin-bottom:2px">To</h4>
              <div class="form-group">
                <div class='input-group date' id='datetimepickerTo'>
                  <div >
                    <label type='text' readonly="true"  v-model="newEvent.end" class="form-control" >{{newEvent.end}}</label>
                  </div>
                  <span class="input-group-addon">
                        <span class="glyphicon glyphicon-calendar"></span>
                  </span>
                </div>
              </div>
            </div>
            </div>
        </div>
    
  
             <br>
        <div class="modal-footer">
            <div class="col-md-12">
          <button class="btn btn-title btn-success" @click="saveEvent()">Save</button>
          <button class="btn btn-title btn-default" @click="cancelEvent()">Cancel</button>
          </div>
        </div>
      </div>
      
    </div>
    
   </div>

  </div>

</div>

</template>

<script>


import Vue from 'vue'
import fc from 'fullcalendar'
import store from '../../../data/store.js'


export default {
        name: 'calendar',
        data() {
            return{
                  eventTypes: [
                    {type: 0, title: 'Not Available for Bookings', color: '#337ab7'},
                    {type: 2, title: 'Fully Boarded (Only can pet sit)', color: 'green'}
                ],
                tempEvent:{
                    id: '',
                    title: '',
                    start: '',
                    end: '',
                    blocking: '',
                    bookingNumber: '',
                    type: '',
                    reservationId: ''
                },
                saving: false,
                error: '',
                alert: '',
                datepicked: '',
                newEvent:{
                    id: '',
                    title: '',
                    eventType: 0,
                    start: '',
                    color: '',
                    end: ''
                },
                events:[]
            }
        },
        methods:{
            goDashboard(){
                var self = this
                if (self.compUserRole=="Sitter" && localStorage.getItem('phoneConfirmed')=="False")
                {
                    
                    swal({
                        title: "Mobile needs verifcation",
                        text: "In order to complete your profile the last step is to verify your Mobile phone, do you want to do it now?",
                        type: "success",
                        showCancelButton: true,
                        confirmButtonClass: 'btn-success',
                        confirmButtonText: "Yes take me there!",
                        cancelButtonText: "Later",
                        allowOutsideClick: false,
                        closeOnConfirm: true,
                        }, function(isConfirm){
                        if (isConfirm){
                        self.$router.push({path: '/account', force: true})
                        return;
                        } else {
                        self.$router.push({path: '/dashboard/feedback-performance',force: true})
                        }
                    });
                } else {
                    self.$router.push({path: '/dashboard/feedback-performance',force: true})
                }
                
            },
            initCalendar(){
                
                self = this
                var now = new Date()
                $('#calendar').fullCalendar({
                
                selectable: true,
                dayRender: function(date, cell) {
                        if (date < now){
                            $(cell).addClass('disabled');
                        }
                },
                allDay: true,
                ignoreTimezone: false,
                selectLongPressDelay: 50,
                displayEventTime: false,
                eventLongPressDelay: 50,
                eventRender: function(event, element) { 
                        if (event.type==0 || event.eventType ==0)
                            element.find('.fc-content').prepend(" <i style='display: initial; margin-left:2px;' class='fa fa-plane'/> " ); 

                        else if (event.type==1 || event.eventType ==1)
                            element.find('.fc-content').prepend ("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> " ); 

                        else if (event.type==2 || event.eventType ==2)
                            element.find('.fc-content').prepend ("<i style='display: initial; margin-left:2px; margin-bottom:0px; padding-bottom:0px' class='fa fa-paw'/> " ); 
                },
                select: function(start, end) { //Creating new event

               
                    if (start <= now){    // If user clicks on past entry to create an event
                        start = moment(now).format('YYYY-MM-DD')
                        //end = moment(now).add(1,"days").format('YYYY-MM-DD')
                    }
                    
                    //self.newEvent.eventType=0
                    var tempStart = moment(start)
                    var tempStartTz = tempStart.tz("Asia/Dubai")
                    var tempEnd = moment(end)
                    var tempEndTz = tempEnd.tz("Asia/Dubai")
                    

                    var duration = moment.duration(tempEndTz.diff(tempStartTz));
                    var hours = duration.asHours();
                    if (duration.asHours()<=24)  //In case of selecting a single day.
                    {
                        
                        tempEndTz = moment(tempEndTz).subtract(23, "hours")
                    } 
                    else
                    {
                        tempEndTz = moment(tempEndTz).subtract(1, "days")
                    }

                    
                    
                    


                    self.newEvent.start = moment(tempStartTz).format('YYYY-MM-DD')
                    self.newEvent.end = moment(tempEndTz).format('YYYY-MM-DD')
                    

                    $('#datetimepickerFrom').datepicker('setDate', moment(self.newEvent.start).format('YYYY-MM-DD'));

                    $('#datetimepickerFrom').datepicker().on('changeDate', function (selected){  //When changing date..
                        self.newEvent.start =  moment(selected.date).format('YYYY-MM-DD')
                    })

                    
                    $('#datetimepickerTo').datepicker('setDate', moment(self.newEvent.end).format('YYYY-MM-DD'));

                    $('#datetimepickerTo').datepicker().on('changeDate', function (selected){   //When changing date..
                        self.newEvent.end =  moment(selected.date).format('YYYY-MM-DD')
                    })


                    $('#newEntryModal').modal('toggle')
                    
			    },
                editable: true,
                eventClick: function(event) {  //edit existing event
                        self.tempEvent.id = event.id
                        self.tempEvent.title = event.title
                        self.tempEvent.blocking = event.blocking,
                        self.tempEvent.bookingNumber = event.bookingNumber,
                        self.tempEvent.reservationId = event.reservationId
                         if (event.eventType!=null){
                            self.tempEvent.type = event.eventType;
                        }
                        else if (event.type!=null){
                            self.tempEvent.type = event.type;
                        } else {
                            self.tempEvent.type= 0
                        }                        
                        self.tempEvent.start = moment(event.start._d).format('MMM Do')
                        if (event.end)
                        {                        
                            self.tempEvent.end = moment(event.end._d).format('MMM Do')
                        }
                        else
                        {
                            self.tempEvent.end = moment(event.start._d).add(1,'days').format('MMM Do') 
                        }
                        $('#calModal').modal('toggle')
                        $('#calModal').on('hidden.bs.modal', function(){   // Empty tempEvent if user decides to close without saving.

                            self.tempEvent = {
                                id: '',
                                title: '',
                                start: '',
                                end: '',
                                type: '',
                                blocking: '',
                                reservationId: ''
                            }
                        })
                        
                        
                },
		    	header: {
                    center:'title',
                    right:'next',
                    left:'prev'
                }
            });
            
            $('#datetimepickerFrom').datepicker({
                autoclose: true,
                ignoreReadonly: true,
                allowInputToggle: true,
                format: 'yyyy-mm-dd',
                beforeShowDay: function(date) {
                        return date.valueOf() >= now;
                    
                },
            });

            

            $('#datetimepickerTo').datepicker({
                format: 'yyyy-mm-dd',
                beforeShowDay: function(date) {
                      if (!$('#datetimepickerFrom').datepicker("getDate")) {
                        return date.valueOf() >= now;
                    } else {
                        return date.valueOf() > $('#datetimepickerFrom').datepicker("getDate");
                    }
                },
                ignoreReadonly: true,
                allowInputToggle: true,
                disableTouchKeyboard: true,
                autoclose: true
            });
            
            },
            goReservation: function(reservationId){
                $('#calModal').modal('hide')
                this.$router.push({name: 'view-sitter-reservation', params: {reservationId: reservationId}})
            },
            noBlocking: function(eventId){
                self = this
                
                $.ajax({
                        type: 'POST',
                        url: 'https://www.dupaws.com/services/api/updateEvent/' + eventId,
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function(xhr){
                                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        success: function () {
                            self.tempEvent.blocking = !self.tempEvent.blocking
                            if (self.tempEvent.color == "green")
                                    {
                                        self.tempEvent.color = "#ff0066"
                                    }
                            else 
                                    {
                                        self.tempEvent.color = "green"
                                    }

                             $('#calendar').fullCalendar('removeEventSources');

                            const index = self.events.findIndex(t => t.id === eventId)
                                if (index != null && self.events.length > 0) {
                                    self.events[index].blocking = !self.events[index].blocking
                                    
                                    if (self.events[index].color == "green")
                                        {
                                            self.events[index].color = "#ff0066"
                                        }
                                    else
                                        {
                                            self.events[index].color = "green"
                                        }


                                }

                            $('#calendar').fullCalendar('addEventSource', self.events);
                            
                            
                            
                            
                            
                            
                        },
                        error:function(){
                        try {
                            self.error = "Couldn't update Event sorry"
                        } catch(e)
                        {
                            self.error = "Oops we are having problem logging to the server, please try again in a moment.."
                        }
                    }
                });

            },
            initEvents(){
                self = this
                $.ajax({
                        type: 'GET',
                        url: 'https://www.dupaws.com/services/api/getEvents',
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function(xhr){
                                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        success: function (data) {
                            var tempEvents = []
                            if (data){

                            var len = data.length;
                            for (var i = 0; i<len; i++){
                                tempEvents.push({
                                    id: data[i].Id,
                                    start: moment(data[i].Start).format('YYYY-MM-DD'),
                                    end: moment(data[i].End).add(12,'hours').format('YYYY-MM-DD HH'),
                                    title: data[i].Title,
                                    bookingNumber: data[i].BookingNumber,
                                    type: data[i].EventType,
                                    color: data[i].Color,
                                    blocking: data[i].Blocking,
                                    reservationId: data[i].ReservationId
                                })
                            }
                            
                            self.events = tempEvents
                           
                            

                            $('#calendar').fullCalendar( 'addEventSource', self.events);
                            } else
                            {

                            }
                            
                            
                        },
                        error:function(){
                        try {
                            self.error = "Couldn't add Event sorry"
                        } catch(e)
                        {
                            self.error = "Oops we are having problem logging to the server, please try again in a moment.."
                        }
                            
                    }
                });

                
                $('#calendar').fullCalendar('rerenderEvents')
            },
            cancelEvent(){
                
                $('#newEntryModal').modal('hide')
                this.newEvent={  //Empty newEvent after saving.
                    id: '',
                    title: '',
                    start: '',
                    end: '',
                    type: 0  
                }
            },
            saveEvent(){
                self = this
                
                self.newEvent.title=self.eventTypes.find(obj => {
                    return obj.type === self.newEvent.eventType
                }).title

                self.newEvent.color=self.eventTypes.find(obj => {
                    return obj.type === self.newEvent.eventType
                }).color


                self.saving=true
                if (self.newEvent.start>self.newEvent.end){
                    swal("Oops", "Please make sure the start date begins before end date","info")
                    return;
                }
                $.ajax({
                        type: 'POST',
                        url: 'https://www.dupaws.com/services/api/addEvent',
                        data: JSON.stringify(self.newEvent),
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function(xhr){
                                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        success: function (data) {
                            self.newEvent.id = data.Id
                            self.newEvent.end = moment(self.newEvent.end).add(12,'hours').format('YYYY-MM-DD HH')
                            $('#calendar').fullCalendar('renderEvent', self.newEvent, true); 
                            
                            self.newEvent={  //Empty newEvent after saving.
                                id: '',
                                title: '',
                                start: '',
                                end: '',
                                eventType: 0

                            }
                            
                            $('#newEntryModal').modal('hide')
                            self.saving = false
                        },
                        error:function(){
                        try {
                            self.error = "Couldn't add Event sorry"
                        } catch(e)
                        {
                            self.error = "Oops we are having problem logging to the server, please try again in a moment.."
                        }
                    }
                });

               
               
            },
            addNewEventButton(){
                var self = this;
                var now = new Date();
                 self.newEvent.title="Traveling"
                    
                 self.newEvent.type=0
                 var tempStart = moment(now)
                 var tempStartTz = tempStart.tz("Asia/Dubai")
                 var tempEnd = moment(tempStart).add(1,'d');
                 var tempEndTz = tempEnd.tz("Asia/Dubai")
                    

                var duration = moment.duration(tempEndTz.diff(tempStartTz));
                var hours = duration.asHours();
                if (duration.asHours()<=24)  //In case of selecting a single day.
                {
                    
                    tempEndTz = moment(tempEndTz).subtract(23, "hours")
                } 
                else
                {
                    tempEndTz = moment(tempEndTz).subtract(1, "days")
                }

                self.newEvent.start = moment(tempStartTz).format('YYYY-MM-DD')
                self.newEvent.end = moment(tempEndTz).format('YYYY-MM-DD')
                

                $('#datetimepickerFrom').datepicker('setDate', moment(self.newEvent.start).format('YYYY-MM-DD'));

                $('#datetimepickerFrom').datepicker().on('changeDate', function (selected){  //When changing date..
                    self.newEvent.start =  moment(selected.date).format('YYYY-MM-DD')
                })

                
                $('#datetimepickerTo').datepicker('setDate', moment(self.newEvent.end).format('YYYY-MM-DD'));

                $('#datetimepickerTo').datepicker().on('changeDate', function (selected){   //When changing date..
                    self.newEvent.end =  moment(selected.date).format('YYYY-MM-DD')
                })


                $('#newEntryModal').modal('toggle')
            },
          
            deleteEvent(){
                var self = this
                var id = self.tempEvent.id
                 $.ajax({
                        type: 'POST',
                        url: 'https://www.dupaws.com/services/api/deleteEvent/' + id,
                        crossDomain: true,
                        contentType: "application/json; charset=utf-8",
                        beforeSend: function(xhr){
                                xhr.setRequestHeader('Authorization','bearer ' + localStorage.getItem('access_token'))
                        },
                        success: function (data) {
                  
                            $('#calendar').fullCalendar('removeEvents',self.tempEvent.id)
                            $('#calModal').modal('hide')

                            self.tempEvent = {
                                id: '',
                                title: '',
                                start: '',
                                end: ''
                            }
                        },
                        error:function(){
                        try {
                            self.error = "Couldn't delete Event sorry"
                        } catch(e)
                        {
                            self.error = "Oops we are having problem logging to the server, please try again in a moment.."
                        }
                            
                    }
                });

                              
            },
            

        },
        created(){
        
        },
        mounted(){
            self = this
            this.$ga.page(this.$router)
            
           
            self.initEvents()      
            self.initCalendar()
           
        },
        updated(){
            $('#datetimePreventFrom').click(function( event ) {
                          event.preventDefault();
            });
            
            $('#datetimePreventTo').click(function( event ) {
                          event.preventDefault();
            });

        },
        beforeDestroy() {
            $('#calendar').fullCalendar('destroy')
            
        },
        computed:{
            scheduleComp: function(){
                if (this.saving==false){
                    return 'Schedule and Calendar'
                }
                else if (this.saving==true){
                    return 'Saving..'
                }
            },
            errorMsg: function(){
            return this.error
            },
            alertMsg: function(){
                return this.alert
            },
            eventsComp: function(){
                return this.events
                
            },
            compUserRole: function(){
                return store.getters.userRole
            }
         
        }
}
</script>

<style scoped>

@media all and (min-width:1000px) {
.margin-big-left{
    margin-left: 10px !important;
    
}

}

.calendar-legend{
    padding:10px;
    border: 1px;
    border-style: solid;
    border-color:#c3c3c3;
    border-radius: 5px;
    background: #dcf7fb;
}

.modal {
  text-align: center;
}


  .modal:before {
    display: inline-block;
    vertical-align: middle;
    content: " ";
    height: 100%;
  }


.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
    .disabled{
        background-color: silver;
    }

    .fc-time{
       display : none;
    }

    .form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
    background-color: #ffffff;
    opacity: 1;
}
</style>





// WEBPACK FOOTER //
// Calendar.vue?d5bcb08a